"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDescriptionProperty = exports.descriptionPropertyDefinition = void 0;
exports.descriptionPropertyDefinition = {
    view: { label: 'Description' },
    constraints: [],
    type: 'rich-text',
    multiple: true,
    name: 'description',
};
const isDescriptionProperty = (prop) => {
    return prop.name === exports.descriptionPropertyDefinition.name;
};
exports.isDescriptionProperty = isDescriptionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVzY3JpcHRpb24ucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9kZXNjcmlwdGlvbi5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDZCQUE2QixHQUFHO0lBQzNDLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUU7SUFDOUIsV0FBVyxFQUFFLEVBQUU7SUFDZixJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxhQUFhO0NBRVksQ0FBQTtBQUkxQixNQUFNLHFCQUFxQixHQUFHLENBQUMsSUFBa0IsRUFBK0IsRUFBRTtJQUN2RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsscUNBQTZCLENBQUMsSUFBSSxDQUFBO0FBQ3pELENBQUMsQ0FBQTtBQUZZLFFBQUEscUJBQXFCLHlCQUVqQyJ9